import React from 'react';
import ListviewMassAssignSS from "../../components/popup/listview/ListviewMassAssignSS";

export default function massAssignSS(params) {
  this.popup(<ListviewMassAssignSS prefix={params.prefix} />);
}
